@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

@keyframes ring-pulse {
  0% {
    transform: scale(0.72);
    opacity: 0.55;
  }
  70% {
    transform: scale(1.08);
    opacity: 0;
  }
  100% {
    transform: scale(1.08);
    opacity: 0;
  }
}

@keyframes box-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes progress-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(250%);
  }
}

@keyframes fade-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 340px);
  padding: 8px 8px 4px;
  text-align: center;
  animation: fade-up 320ms ease;

  @media (max-width: 480px) {
    width: min(100%, 300px);
  }
}

.visual {
  position: relative;
  display: grid;
  place-items: center;
  width: 96px;
  height: 96px;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    width: 72px;
    height: 72px;
    margin-bottom: 16px;
  }
}

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 400px);
  margin: auto;
  padding: 28px 24px 24px;
  border-radius: 20px;
  box-shadow: v.$shadow4;
  background: v.$palette-white;
  box-sizing: border-box;

  @media (max-width: 480px) {
    width: min(100%, 100%);
    padding: 20px 16px 16px;
    border-radius: 16px;
  }
}

.ring,
.ringSecondary {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid v.$palette-orange-2;
  animation: ring-pulse 1.8s ease-out infinite;
}

.ringSecondary {
  animation-delay: 0.9s;
  border-color: v.$palette-orange-1;
}

.core {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  width: 52px;
  height: 52px;
  padding: 10px 8px 8px;
  border-radius: 14px;
  background: linear-gradient(180deg, v.$palette-orange-4 0%, v.$palette-white 100%);
  box-shadow: v.$shadow2;
  border: 1px solid v.$palette-dirty-20;
}

.box {
  display: block;
  width: 10px;
  border-radius: 2px;
  background: linear-gradient(180deg, v.$palette-orange-1 0%, v.$palette-orange-2 100%);
  animation: box-float 1.2s ease-in-out infinite;

  &:nth-child(1) {
    height: 14px;
    animation-delay: 0s;
  }

  &:nth-child(2) {
    height: 22px;
    animation-delay: 0.15s;
  }

  &:nth-child(3) {
    height: 18px;
    animation-delay: 0.3s;
  }
}

.title {
  margin: 0 0 8px;
  font-family: v.$primary-font;
  @include t.text(18px, 28px, 600);
  color: v.$default-text-color;
}

.description {
  margin: 0 0 20px;
  max-width: 280px;
  font-family: v.$primary-font;
  @include t.text(14px, 22px, normal);
  color: v.$palette-dirty-100;
}

.progress {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 4px;
  border-radius: 999px;
  background: v.$palette-dirty-20;
}

.progressBar {
  position: absolute;
  top: 0;
  left: 0;
  width: 40%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, v.$palette-orange-1, v.$palette-orange-2);
  animation: progress-slide 1.35s ease-in-out infinite;
}
